import Big from 'big.js';

export const getPriceInCents = (priceInCurrency?: number | string) => {
  if (!priceInCurrency && priceInCurrency !== 0) {
    return undefined;
  }

  const priceAsNumber = Number(priceInCurrency);

  if (isNaN(priceAsNumber)) {
    return undefined;
  }

  return new Big(priceAsNumber).mul(100).toNumber();
};

export const getTipInCents = (amountInCurrency?: number | string, tipInPercent?: number | string) => {
  const amountInCents = getPriceInCents(amountInCurrency);

  if (typeof tipInPercent === 'undefined' || typeof amountInCents !== 'number') {
    return undefined;
  }

  const tipPercentageAsNumber = Number(tipInPercent);

  if (isNaN(tipPercentageAsNumber)) {
    return undefined;
  }

  return new Big(amountInCents).div(100).mul(tipPercentageAsNumber).toNumber();
};

export const getAmountInRespectiveCurrency = (amountInCents: number) => {
  try {
    return new Big(amountInCents).div(100).toNumber();
  } catch (error) {
    console.error(
      `Error while converting amount in cents - value: "${amountInCents}", type: "${typeof amountInCents}" to currency: ${error}`,
    );
    return 0;
  }
};

export const getTipAmount = (donationAmount: number, tipPercentage: number) => {
  try {
    return new Big(donationAmount).div(100).mul(tipPercentage).toNumber();
  } catch (error) {
    console.error(
      `Error while converting values: 
      value: "${donationAmount}" and type: "${typeof donationAmount}" 
      and tipPercentage - value: "${tipPercentage}", type: ${typeof tipPercentage} 
      ${error}`,
    );
    return 0;
  }
};

export const getDonationAmountIncludingTip = (
  donationAmount: number,
  tipPercentage: number,
  customTipAmount?: number,
) => {
  try {
    if (customTipAmount) {
      return new Big(donationAmount).add(customTipAmount).toNumber();
    }

    return new Big(donationAmount).add(getTipAmount(donationAmount, tipPercentage)).toNumber();
  } catch (error) {
    console.error(
      `Error while converting values: 
      value: "${donationAmount}" and type: "${typeof donationAmount}", 
      tipPercentage - value: "${tipPercentage}", type: "${typeof tipPercentage}"
      and customTipAmount - value "${customTipAmount}", type: "${typeof customTipAmount}" 
      ${error}`,
    );
    return 0;
  }
};

export const isNumber = (value: unknown): value is number => {
  return typeof value === 'number';
};

export const isStringParsableToNumber = (value: string) => {
  return !isNaN(Number(value));
};

export const getPercents = (value: number, total: number) => {
  try {
    return new Big(value).div(total).mul(100).toNumber();
  } catch (error) {
    console.error(
      `Error while converting values: 
      value: "${value}" and type: "${typeof value}", 
      total - value: "${total}", type: "${typeof total}"
      ${error}`,
    );
    return 0;
  }
};
